/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Factory for creating the static render function for a browser
 */

export const createBrowserStaticRender =
  (staticMap: Map<string | null, string>) =>
  ({ name }: { name: string }) => {
    return staticMap.get(name) || null
  }
